import React, { useState } from 'react';
import { FaSpinner } from 'react-icons/fa';

interface IProps {
    onClick:()=>Promise<boolean>;
    startingText?:string
    progressText?:string
    completedText?:string
    disabled?:boolean
}

const AnimatedSaveButton:React.FC<IProps> = (props:IProps) => {
    
    const startingText = props.startingText || 'Save';
    const progressText = props.progressText || 'Saving...'
    const completedText = props.completedText || 'Saved!'
    const [ status, setStatus ] = useState<'idle' | 'saving' | 'completed'>('idle');

    // Only progress/completed text is held transiently; the resting label always reflects the
    // current startingText prop so it stays in sync when the parent changes it.
    const buttonText = status === 'saving' ? progressText : status === 'completed' ? completedText : startingText;

    const save = async ()=>{
        setStatus('saving');

        const success = await props.onClick();
        if (success) {
            setStatus('completed');
            setTimeout(()=>{ setStatus('idle'); }, 3000)
        } else {
            setStatus('idle');
        }
    }

    return (
        <button className="saveButton" onClick={save} disabled={status === 'saving' || props.disabled}>
        <span>{buttonText}</span>
            {status === 'saving' && <FaSpinner className="fa-spin" size={16} color="white" />}
        </button>
    )
}

export default AnimatedSaveButton;